<template>
  <van-dropdown-menu
    :close-on-click-overlay="false"
    class="search border-bottom"
    active-color="#1989fa"
  >
    <van-dropdown-item title="搜索" ref="search">
      <van-search
        v-model="value"
        show-action
        autofocus
        placeholder="客户名称/手机号"
      >
        <template #action>
          <van-button size="small" @click="searchCustomer">搜索</van-button>
        </template>
      </van-search>
    </van-dropdown-item>
    <van-dropdown-item title="筛选" ref="filter">
      <div class="operate">
        <van-button
          size="small"
          @click="
            (search.customerLableIds = []),
              (search.customerIntention = undefined)
          "
          >重置</van-button
        >
        <van-button size="small" @click="handleConfirm">确定</van-button>
      </div>
      <van-collapse class="filter" v-model="activeNames">
        <van-collapse-item :title="copyTag.label" :name="copyTag.value">
          <van-tag
            v-for="tag in copyTag.children"
            :key="tag.id"
            size="large"
            plain
            :type="
              search.customerLableIds.includes(tag.id) ? 'primary' : 'default'
            "
            @click="handleTag(tag)"
          >
            {{ tag.name }}
          </van-tag>
        </van-collapse-item>
        <van-collapse-item
          v-for="item in customeTag"
          :key="item.value"
          :title="item.label"
          :name="item.value"
        >
          <van-tag
            v-for="tag in item.children"
            :key="tag.id"
            size="large"
            plain
            :type="
              search.customerLableIds.includes(tag.id)
                ? 'primary'
                : search.customerIntention === tag.name
                ? 'primary'
                : 'default'
            "
            @click="handleTag(tag)"
          >
            {{ tag.name }}
          </van-tag>
        </van-collapse-item>
      </van-collapse>
    </van-dropdown-item>
    <van-dropdown-item
      v-model="search.type"
      :options="sortOptions"
      @change="$emit('queryList', search)"
    />
  </van-dropdown-menu>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "QueryCustomer",
  data() {
    return {
      copyTag: {
        children: [
          {
            id: 11111,
            name: "手动创建",
            level: 0,
            type: 0,
            typeName: "客户来源",
          },
          {
            id: 44444,
            name: "批量导入",
            level: 0,
            type: 0,
            typeName: "客户来源",
          },
          {
            id: 22222,
            name: "抖音小店",
            level: 0,
            type: 0,
            typeName: "客户来源",
          },
          {
            id: 33333,
            name: "小鹅通",
            level: 0,
            type: 0,
            typeName: "客户来源",
          },
        ],
        label: "客户来源",
        value: 0,
      },
      value: "",
      search: {
        customerName: undefined,
        customerTel: undefined,
        type: 1,
        customerLableIds: [],
        customerIntention: undefined,
      },
      sortOptions: [
        {
          text: "最后跟进",
          value: 1,
        },
        {
          text: "最新加入",
          value: 2,
        },
        {
          text: "最新分配",
          value: 3,
        },
      ],
      activeNames: [],
      tagList: [],
    };
  },
  created() {
    this.customeTag.forEach((item, index) => {
      if (item.value === 7) {
        this.customeTag.splice(index, 1);
      }
      if (item.value === 8) {
        this.customeTag.splice(index, 1);
      }
    });
    if (!this.customeTag || !this.customeTag.length) {
      this.$store.dispatch("app/GetCustomerTag");
    }
  },
  computed: {
    ...mapGetters(["customeTag"]),
  },
  methods: {
    searchCustomer() {
      const numReg = /^[0-9]+$/;
      if (!numReg.test(this.value)) {
        Object.assign(this.search, {
          customerName: this.value || undefined,
        });
      } else {
        Object.assign(this.search, {
          customerTel: this.value || undefined,
        });
      }
      this.$refs.search.toggle();
      this.$emit("queryList", this.search);
    },
    handleConfirm() {
      console.log(this.search);
      this.$refs.filter.toggle();
      this.$emit("queryList", this.search);
    },
    handleTag(item) {
      const { id, name } = item;

      const index = this.search.customerLableIds.indexOf(id);
      if (index !== -1) {
        this.search.customerLableIds.splice(index, 1);
      } else {
        this.search.customerLableIds.push(id);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.search {
  background-color: #fff;

  /deep/ .van-dropdown-menu__bar {
    background-color: transparent;
    box-shadow: none;
    height: 40px;
  }

  /deep/ .van-dropdown-menu__item {
    position: relative;

    &:not(:last-of-type)::after {
      content: "";
      position: absolute;
      width: 1px;
      height: 100%;
      right: 0;
      bottom: 0;
      border-right: 1px solid #ebedf0;
      transform: scaleX(0.5);
    }
  }

  .operate {
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;

    .van-button {
      flex: 1;
      margin-right: 15px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .filter {
    .van-tag {
      margin-right: 10px;

      &--primary {
        background-color: #1989fa;
        color: #fff;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
